import { FormLibrary } from '@goldcast/api/backend';

import { State } from './types';

import router from '@/router';
import { FieldMappingBooleans } from '@/studio/orgIntegration/store/types';

const getters = {
  getCurrentForm(state: State): FormLibrary | null {
    return state.currentForm;
  },
  getIsFormMapping(): boolean {
    const path = router?.currentRoute?.value?.path?.toLowerCase();
    return path.startsWith('/settings-new/forms');
  },
  areThereInvalidFormFieldMapping(state: State, _, rootState): FieldMappingBooleans {
    const crmObjectTypes = rootState?.orgIntegration?.crmObjectTypes || [];
    const areThereInvalidFieldMapping = {};
    crmObjectTypes.forEach(({ crm_object_type }) => {
      areThereInvalidFieldMapping[crm_object_type] =
        state.formFieldMappingRowError?.[crm_object_type]?.some(
          rowError => rowError?.code === 'MISSING_TARGET_FIELD' || rowError?.code === 'MISSING_TEMPLATE_SOURCE_FIELD'
        ) || false;
    });
    return areThereInvalidFieldMapping;
  },
  areThereFormFieldMappingError(state: State, _, rootState): FieldMappingBooleans {
    const crmObjectTypes = rootState?.orgIntegration?.crmObjectTypes;
    const areThereFieldMappingError = {};
    crmObjectTypes.forEach(({ crm_object_type }) => {
      areThereFieldMappingError[crm_object_type] = state.formFieldMappingRowError[crm_object_type].some(
        rowError => rowError !== null
      );
    });
    return areThereFieldMappingError;
  },
  areThereFormFieldMappingChanges(state: State, _, rootState): FieldMappingBooleans {
    const crmObjectTypes = rootState?.orgIntegration?.crmObjectTypes ?? [];
    const areThereFieldMappingChanges = {};
    crmObjectTypes.forEach(({ crm_object_type }) => {
      const currentMappings = state.formFieldMappings[crm_object_type]?.mappings ?? [];
      const previousMappings = state.prevFormFieldMappings[crm_object_type] ?? [];
      if (currentMappings.length !== previousMappings.length) {
        areThereFieldMappingChanges[crm_object_type] = true;
        return;
      }
      areThereFieldMappingChanges[crm_object_type] = currentMappings.some((fieldMapping, index) => {
        const prevMapping = previousMappings[index];
        return JSON.stringify(fieldMapping) !== JSON.stringify(prevMapping);
      });
    });
    return areThereFieldMappingChanges;
  }
};

export default getters;
